import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
export function PricingCTA() {
  const handleAddToCart = () => {
    trackAddToCart({
      content_name: 'El Tesoro de Dubái en Casa',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section id="pricing" className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-125">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold/10 via-dark to-dark" data-id="element-126"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-card to-dark border border-gold/30 rounded-2xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(197,165,90,0.1)]" data-id="element-128">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-6" data-id="element-129">
            Obtén hoy mismo el acceso completo a <br data-id="element-130" />
            <span className="text-gold" data-id="element-131">El Tesoro de Dubái en Casa</span>
          </h2>

          <p className="font-sans text-lg text-cream-muted mb-8" data-id="element-132">
            Y domina la receta viral antes de que pase la tendencia.
          </p>

          <div className="mb-10" data-id="element-133">
            <p className="text-sm text-cream-muted uppercase tracking-widest mb-2" data-id="element-134">
              Precio exclusivo de lanzamiento
            </p>
            <div className="inline-block bg-red-600 text-cream font-sans font-bold text-sm px-4 py-1.5 rounded-full mb-4 tracking-wide" data-id="element-135">
              68% DE DESCUENTO
            </div>
            <div className="flex items-center justify-center gap-4" data-id="element-136">
              <span className="font-serif text-6xl text-gold font-bold" data-id="element-137">
                $6.39
              </span>
            </div>
          </div>

          <motion.a href="https://auriadigitalstore.com/cart/52265066430757:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto bg-gold hover:bg-gold-light text-dark font-sans font-bold text-xl px-10 py-5 rounded-sm transition-all duration-300 shadow-[0_0_30px_rgba(197,165,90,0.4)] hover:shadow-[0_0_40px_rgba(197,165,90,0.6)] text-center" data-id="element-138">
            ¡QUIERO MI GUÍA DEL LEYENDA DE DUBÁI AHORA!
          </motion.a>

          <p className="mt-6 font-sans text-sm text-cream-muted/70 flex items-center justify-center gap-2" data-id="element-139">
            <span className="w-2 h-2 rounded-full bg-emerald animate-pulse" data-id="element-140"></span>
            Acceso inmediato tras la compra. Empieza a cocinar en 5 minutos.
          </p>
        </motion.div>
      </div>
    </section>;
}